import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Logo / Brand */}
        <div className="footer-logo">
          <h2>NextEdge</h2>
          <p>Innovating the digital world, one project at a time.</p>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#portfolio">Portfolio</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* Social Media */}
        <div className="footer-social">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <a href="https://www.instagram.com/_next_edge_?igsh=MWFzczd3bGZnaGN3Yg==" target="_blank"><i className="fab fa-instagram"></i></a>
            <a href="#"><i className="fab fa-facebook"></i></a>
            {/* <a href="#"><i className="fab fa-twitter"></i></a> */}
            {/* <a href="#"><i className="fab fa-linkedin"></i></a> */}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} NextEdge. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
